// extracted by mini-css-extract-plugin
export default {"navbar":"RootLayout_navbar__mrkvl","contentArea":"RootLayout_contentArea__CuM-0","logoHeader":"RootLayout_logoHeader__5fliO","wrapper":"RootLayout_wrapper__QOAv8"};